import { jsxs, jsx } from "react/jsx-runtime";
import * as React from "react";
import { cx } from "../internal/cx.js";
function ClockIcon({ label }) {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      className: "ev-live-value__clock",
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: "currentColor",
      strokeWidth: "1.8",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      role: "img",
      "aria-label": label,
      focusable: "false",
      children: [
        /* @__PURE__ */ jsx("circle", { cx: "12", cy: "12", r: "8.5" }),
        /* @__PURE__ */ jsx("path", { d: "M12 7.5V12l3 2" })
      ]
    }
  );
}
const LiveValue = React.forwardRef(function LiveValue2({ value, unit, label, freshness, freshnessDateTime, stale = false, staleLabel = "Stale", className, ...rest }, ref) {
  const hasLabel = label != null && label !== false && label !== "";
  const hasUnit = unit != null && unit !== false && unit !== "";
  const hasFreshness = freshness != null && freshness !== "";
  return /* @__PURE__ */ jsxs("span", { ref, className: cx("ev-live-value", className), "data-stale": stale ? "true" : void 0, ...rest, children: [
    hasLabel ? /* @__PURE__ */ jsx("span", { className: "ev-live-value__label", children: label }) : null,
    /* @__PURE__ */ jsxs("span", { className: "ev-live-value__reading", children: [
      /* @__PURE__ */ jsx("span", { className: "ev-live-value__value", children: value }),
      hasUnit ? /* @__PURE__ */ jsx("span", { className: "ev-live-value__unit", children: unit }) : null
    ] }),
    hasFreshness || stale ? /* @__PURE__ */ jsxs("span", { className: "ev-live-value__fresh", children: [
      stale ? /* @__PURE__ */ jsx(ClockIcon, { label: staleLabel }) : null,
      !hasFreshness ? null : freshnessDateTime ? /* @__PURE__ */ jsx("time", { dateTime: freshnessDateTime, children: freshness }) : freshness
    ] }) : null
  ] });
});
export {
  LiveValue
};
//# sourceMappingURL=LiveValue.js.map
